/**
 * @fileoverview IrisDisclaimer — small muted disclaimer Foundry
 * renders at the top of the IRIS message list ("IRIS is
 * powered by third-party generative AI..."). Visually styled with the
 * Blueprint `bp6-text-muted bp6-text-small` pair.
 *
 * Foundry mapping: `aip-assist-impl__disclaimer.bp6-text-muted.bp6-text-small`.
 */

import type { ReactElement, ReactNode } from "react";

interface IrisDisclaimerProps {
  children: ReactNode;
  className?: string;
}

export function IrisDisclaimer({
  children,
  className,
}: IrisDisclaimerProps): ReactElement {
  return (
    <div data-testid="iris-disclaimer"
      className={[
        "bp-iris-disclaimer",
        "bp6-text-muted",
        "bp6-text-small",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
}
